export default __webpack_public_path__ + "static/content-containers-dark-45e5607525eb0c83922737a4db6475a2.png";